<mat-card>

  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{ "title.edit_config" | translate }} <span *ngIf="enterprise != null && enterprise.name != null">: {{enterprise.name}}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <!--        start-->


        <mat-tab-group #myTabGroup (selectedIndexChange)="isInforTab = $event">
          <mat-tab [label]="'title.contract_config_tab' | translate">
          </mat-tab>
          <mat-tab
            [label]="'title.enterprise_config_tab' | translate">
            <app-enterprise-config-enterprise
              [enterpriseConfigHsmAndBranch]="enterpriseConfigHsmAndBranch"
              (getDataIp)="loadData()"
              ></app-enterprise-config-enterprise>
          </mat-tab>
        </mat-tab-group>

        <mat-card-content [ngClass]="isInforTab === 0 ? '' : 'd-none'">
          <mat-accordion #accordion="matAccordion" [multi]="true">

            <form [formGroup]="form" (ngSubmit)="onSave()" novalidate>
              <div class="pt-3" [hidden]="true" >
                <mat-checkbox color="primary" disabled [checked]="maxSize !== -1">
                  <strong>{{titleMaxSize}}</strong>
                </mat-checkbox>
                <div class="d-flex">
                  <em>{{subTitleMaxSize}}.</em>
                </div>
              </div>

              <div class="pt-3">
                <mat-checkbox color="primary" (change)="onCheckboxChange($event)" #enableOcsp formControlName="enableOcsp">
                  <strong>{{'title.allow_ocsp' | translate}}</strong>
                </mat-checkbox>
                <div class="d-flex">
                  <em>{{'messages.allow_ocsp' | translate}}
                    <br>
                    <em>{{'messages.see_more_detail' | translate}}</em> <a tabindex="0"
                                                                           routerLink="/registration-terms-information-sign"
                                                                           target="_blank"> {{'form.rule' | translate}} </a>.</em>
                </div>
              </div>


              <!-- Huỷ bỏ & Lưu  -->
              <mat-card-actions class="text-center">
                <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
                  <mat-icon class="mr-0">cancel</mat-icon>
                  {{'button.cancel' | translate}}
                </button>
                <button mat-raised-button
                        type="submit"
                        [disabled]="!dirty"
                        color="primary">
                  <mat-icon class="mr-0">save</mat-icon>
                  {{'button.save' | translate}}
                </button>
              </mat-card-actions>


            </form>


          </mat-accordion>
        </mat-card-content>




        <!--        end-->
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
